import { render } from "./App.vue?vue&type=template&id=17b04732"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17b04732&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__